export default __webpack_public_path__ + "fc9cb410f808f8594da5979ceea7f9c8.png";